var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatLcok = function SvgChatLcok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 2",
    viewBox: "0 0 48.39 44.62"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.43 6.48h18.55c.53 0 .92.11 1.4.33.44.47.52.78.52 1.41-.05.49-.31.74-.67 1.04-.4.22-.72.24-1.16.23H8.32c-1.55 0-2.88.12-4.07 1.22-.83.87-1.17 1.82-1.17 3.01V30.2c-.01 1.46.17 2.71 1.2 3.83 1.17 1.11 2.63 1.21 4.16 1.2h3.68q1.08.01 1.55.44c.33.38.4.7.41 1.19v1c0 .37.01.73.02 1.1 0 .25 0 .5.01.74l.03 1.82c.08-.06.15-.13.23-.19.53-.44 1.06-.89 1.61-1.31.12-.09.23-.18.35-.27q.09-.07.17-.14c.29-.22.57-.45.86-.67.11-.09.23-.18.34-.27.06-.04.11-.09.17-.13l.51-.4q.08-.07.17-.13c.11-.09.23-.18.34-.27l.86-.68q2.26-1.79 2.9-1.79h3.19c1.24 0 2.47-.01 3.71-.02.68 0 1.36 0 2.05-.01h2.65c1.34-.01 2.59-.22 3.65-1.11 1.02-1.09 1.25-2.28 1.25-3.72v-.65c0-.62 0-1.24.01-1.85v-2.52c.06-.48.22-.8.57-1.13.42-.28.82-.33 1.32-.26.47.16.75.4.99.84.19.55.14 1.15.13 1.73v3.87c0 2.13-.52 4.08-1.99 5.68-1.94 1.85-3.98 2.11-6.53 2.08h-1.28c-1.21 0-2.42 0-3.62-.02h-3.07q-1.75-.1-3.29.59c-.16.16-.32.33-.48.5-.12.1-.25.2-.37.29l-.3.24c-.11.09-.23.18-.34.27q-.09.07-.17.14c-.29.22-.57.45-.86.67-.11.09-.23.18-.34.27-.23.18-.46.36-.68.54q-.08.07-.17.13c-.11.09-.23.18-.34.27-.29.23-.58.45-.87.68q-2.56 2.03-4.24 1.87c-.7-.18-1.3-.6-1.71-1.19-.41-.7-.45-1.29-.45-2.1V38.2h-.18c-.64 0-1.27.01-1.91.02h-.71c-2.42.03-4.43-.3-6.24-2.03a7.44 7.44 0 0 1-2.01-5.12v-16.6C.01 12.19.48 10.2 2.1 8.5c1.48-1.39 3.33-2.03 5.34-2.03Z",
    className: "chat-lcok_svg__cls-1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.91,
    height: 2.54,
    x: 8.6,
    y: 14.09,
    className: "chat-lcok_svg__cls-1",
    rx: 1.24,
    ry: 1.24
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.91,
    height: 2.54,
    x: 8.6,
    y: 20.1,
    className: "chat-lcok_svg__cls-1",
    rx: 1.24,
    ry: 1.24
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.33,
    height: 2.54,
    x: 13.18,
    y: 25.26,
    className: "chat-lcok_svg__cls-1",
    rx: 1.03,
    ry: 1.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.05 8.5h-.44V6.17c0-1.65-.64-3.2-1.81-4.36C41.63.64 40.09 0 38.44 0s-3.2.64-4.36 1.81a6.1 6.1 0 0 0-1.81 4.36V8.5h-.45c-1.84 0-3.33 1.5-3.33 3.33v6.61c0 1.84 1.5 3.33 3.33 3.33h13.23c1.84 0 3.33-1.5 3.33-3.33v-6.61c0-1.84-1.5-3.33-3.33-3.33m-6.61-5.61c.88 0 1.7.34 2.32.96s.96 1.44.96 2.32V8.5h-6.56V6.17c0-.88.34-1.7.96-2.32.61-.61 1.46-.96 2.32-.96m-7.06 8.95c0-.25.2-.44.45-.44h13.23c.25 0 .45.2.45.44v6.61c0 .25-.2.44-.45.44H31.83c-.25 0-.45-.2-.45-.44z",
    className: "chat-lcok_svg__cls-1"
  }))));
};
export default SvgChatLcok;